import React, { FC } from 'react';
import styled from 'styled-components';
import { ResourceListSkeleton } from '../../widgets/resourceList';
import { SkeletonBlock, SkeletonPageHeader, SkeletonPageShell, SkeletonRow, SkeletonStack } from '../../widgets/skeleton';

const PageShell = styled(SkeletonPageShell)`
    height: 100%;
    min-height: 0;
    padding-top: 0;
`;

export const AICreativeToolsCustomAppsPageSkeleton: FC = () => (
    <PageShell>
        <SkeletonPageHeader>
            <SkeletonStack $gap='8px'>
                <SkeletonBlock $width='120px' $height='12px' />
                <SkeletonBlock $width='190px' $height='26px' />
            </SkeletonStack>
        </SkeletonPageHeader>
        <SkeletonRow $justify='flex-end' $margin='0 0 16px'>
            <SkeletonBlock $width='82px' $height='32px' $radius='6px' />
        </SkeletonRow>
        <ResourceListSkeleton tableColumns={['minmax(180px, 1fr)', 'minmax(180px, 1fr)', '50px']} />
    </PageShell>
);
